export default __webpack_public_path__ + "static/media/dozingInTheBackSeat.223c2364.webm";